import { render, staticRenderFns } from "./ChartStats.vue?vue&type=template&id=4b77f1d5&"
import script from "./ChartStats.vue?vue&type=script&lang=js&"
export * from "./ChartStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports